var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0C5.60501 0 0 5.61002 0 12.5C0 19.395 5.60501 25 12.5 25C19.39 25 25 19.395 25 12.5C25 5.61002 19.39 0 12.5 0ZM17.32 12.895L10.295 18.395C10.205 18.465 10.1 18.5 9.99002 18.5C9.91501 18.5 9.84 18.485 9.77002 18.45C9.595 18.365 9.49002 18.19 9.49002 18V7.005C9.49002 6.815 9.595 6.64001 9.77002 6.55499C9.94 6.47 10.145 6.495 10.295 6.61002L17.32 12.11C17.44 12.205 17.51 12.35 17.51 12.5C17.51 12.655 17.44 12.8 17.32 12.895Z",
    fill: "#2C79C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.019f673d5e3d045ffbe030ece41af4a5.svg";
export { ForwardRef as ReactComponent };